<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center" >
      <b-col md="10" lg="8">
        <b-card v-show="showList">
          <div slot="header">Notification Configuration 
            <div class="card-header-actions">
              <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
              <button class="btn btn-primary mr-1" @click="exportxls()">
                  <i class="fa fa-file-excel-o"></i>
                  Export
              </button>
              <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
            </div>
          </div>
          <b-row >
            <b-col md="11">
                  <b-input-group >
                        <b-input-group-prepend><span class="p-2">Filter</span></b-input-group-prepend>
                      <b-form-input readonly v-model="filter.username" placeholder="Select User !" ></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="showLkuUser('filter.username')">
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
                        <b-input-group-prepend><span class="p-2">Notification Name</span></b-input-group-prepend>
                      <b-form-select v-model="filter.notifyname" :plain="true" :options="notifyMaster"></b-form-select>
                      <b-input-group-append>
                            <b-button variant="success" size="sm" @click="refresh()" class="ml-3"> <i class="fa fa-refresh"></i> Apply Filter</b-button>                
                      </b-input-group-append>
                      <b-input-group-append>
                            <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()" >Clear Filter</b-button>
                      </b-input-group-append>

                  </b-input-group>
            </b-col>
          </b-row>

          <b-table
            class="mb-0"
            ref="table"
            outlined  responsive hover small
            style="font-size:smaller;" 
            :items="data"
            :fields="tblFields"
            :current-page="tblData.page"
            @row-clicked="rowClicked"
          >
            <template v-slot:cell(nomor)="data">
              {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
            </template>
            <template v-slot:cell(action)="data">
              <div class="text-center">
              <a href="javascript:void(0)" @click.stop="edit(data.item)">
                <i class="fa fa-pencil"></i>
              </a>
              |
              <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
                <i class="fa fa-trash"></i>
              </a>
              </div>
            </template>
          </b-table>
          <b-row class="mt-2">
            <b-col cols="6">
              <div>
                Showing {{(tblData.page - 1) * tblData.limit + 1}}
                to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
                of {{tblData.total}} entries
              </div>
            </b-col>
            <b-col cols="6">            
              <b-pagination
                align="right"
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
            </b-col>
          </b-row>

          <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
            <p class="mb-1">1 record is about to be permanently deleted</p>
            <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
          </b-modal>
        </b-card>
        <b-card v-if="showForm">
          <div slot="header">Mapping Notification vs User - Add/Edit Form 
            <div class="card-header-actions">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
              <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>
          </div>
            <b-row >
              <b-col class="pr-4" cols="6">
                  <b-form-group label-cols=3  label="User Name">
                      <b-input-group >
                          <b-form-input readonly v-model="frmdata.username" :state="!$v.frmdata.username.$error"></b-form-input>
                          <b-input-group-append>
                          <b-btn text="Button" @click="showLkuUser('frmdata.username')" >
                              <i class="fa fa-search"></i>
                          </b-btn>
                          </b-input-group-append>
                      </b-input-group>
                  </b-form-group>
                  <b-form-group label-cols=3  label="Notification Name">
                      <b-form-select v-model="frmdata.notifyname" :plain="true" :options="notifyMaster" :state="!$v.frmdata.notifyname.$error"></b-form-select>
                  </b-form-group>
              </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
      
    <b-modal v-model="lkuUserShow" size="lg" :hide-footer="true" title="List of Users" :centered="true">
        <lku-user @click="onSelectUser"></lku-user>
    </b-modal>        
  </div>
</template>


<script>
import lkuUser from "../lookup/lkuUser";
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import crudexport from "../../apis/crudexport";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  components: {lkuUser},
  mixins: [validationMixin],
  validations: {
    frmdata: {
        username: { required },
        notifyname: { required },
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showList:true,
      showForm:false,
      lkuUserShow:false,
      lkuUserCaller:'filter.username',
      filter:{username:'',notifyname:''},
      frmdata:{notifyname: '', username: '' },
      tblData: {
        tablename:'notifyconfig',
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
      },
      notifyMaster:[]
    };
  },
  computed: {
    tblFields(){
      const fields=[
          {
            key: "nomor",
            thStyle: "width:50px",
            label: "No.",
          },
          {
            key: "username",
            label: "User Name",
            sortable: true
          },
          {
            key: "notifyname",
            label: "Notification Name",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:40px",
            thClass: "text-center",
          }          
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },

  },
  created: async function(){
      // this.notifyMaster = [{value:'po receiving', text:'New PO Receiving'},
      //                     {value:'purchase request', text:'Action on Purchase Request'},      
      //                     {value:'PR BARTER', text:'Action on PR BARTER'},      
      //                     {value:'material request', text:'Action on Material Request'},      
      //                     {value:'new fa', text:'New Fixed Asset'},      
      //                     {value:'new fa accounting', text:'New Fixed Asset Depreciation'},      
      // ]; 
      const pilihan =await crud.list({tablename:'notification'});
      // console.log(pilihan);
      pilihan.forEach(p => {
        this.notifyMaster.push({value:p.notifyname, text:p.notifydescript})
      });
  },
  methods: {
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            let str ='isdeleted=0';
            if (this.filter.username){
              str += str ? '&' : '';
              str = str + 'username=' + encodeURIComponent(this.filter.username);
            }
            if (this.filter.notifyname){
              str += str ? '&' : '';
              str = str + 'notifyname=' + encodeURIComponent(this.filter.notifyname);
            }
            this.tblData.customQuery=str;      

      const list = await crud.list(this.tblData);      
      return list;
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            let str ='isdeleted=0';
            if (this.filter.username){
              str += str ? '&' : '';
              str = str + 'username=' + encodeURIComponent(this.filter.username);
            }
            if (this.filter.notifyname){
              str += str ? '&' : '';
              str = str + 'notifyname=' + encodeURIComponent(this.filter.notifyname);
            }
            this.tblData.customQuery=str;      

            await crudexport.notification(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },     
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.filter.username= '';
        this.filter.notifyname='';
        this.refresh();
    },

    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.frmdata.username=this.filter.username
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              if (this.frmdata.tablekey) {
                await crud.update(
                     {tablename:'notifyconfig', 
                     key:this.frmdata.tablekey, 
                     data:{username:this.frmdata.username,
                          notifyname:this.frmdata.notifyname
                          }
                      });
              } else {
                await crud.insert(
                  { tablename:'notifyconfig',                      
                     data:{username:this.frmdata.username,
                          notifyname:this.frmdata.notifyname
                          }
                  });
              }
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({tablename:'notifyconfig', key:this.model.tablekey});
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    showLkuUser(callerObj)
    {
      this.lkuUserShow=true;
      this.lkuUserCaller=callerObj;
    },
    // onSelectLkuUser(_selected) {
    //     this[this.lkuUserCaller] = _selected.username;;
    //     // this.filter.full_name = _selected.full_name;
    //     this.lkuUserShow=false;
    // },
    onSelectUser(_selected) {
      const arrCaller=this.lkuUserCaller.split('.');
        this[arrCaller[0]][arrCaller[1]] = _selected.username;;
        // this.filter.full_name = _selected.full_name;
        this.lkuUserShow=false;
    },

    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
